module.exports = __webpack_public_path__ + "static/media/recovery-card2x.8627377a.jpg";